/*
 * @Author: your name
 * @Date: 2022-01-12 10:27:53
 * @LastEditTime: 2022-01-12 10:51:52
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wp-empowerment-tools-web\src\services\customer.ts
 */

import { CUSTOMER } from "../const"
import request from "../utils/request"

const getCustomerIdByUserId = (externalUserid: String) => {
  return request.get(`${CUSTOMER.getCustomerIdByUserId}/${externalUserid}`)
}
const getCustomerInfoByCustomerId = (customerId: String) => {
  return request.get(`${CUSTOMER.getCustomerInfoByCustomerId}/${customerId}`)
}

const getCustomerBusinessOppo = (params: any) => {
  return request.post(`${CUSTOMER.getCustomerBusinessOpportunity}`, {
    data: params,
  })
}

const getClaimRecords = (customerId: any, params: any) => {
  return request.post(`${CUSTOMER.getClaimRecords}/${customerId}`, {
    data: params,
  })
}

const getUnderWritingRecord = (params: any) => {
  return request.post(`${CUSTOMER.getUnderWritingRecord}`, { data: params })
}

const getAuditPage = (params: any) => {
  return request.post(`${CUSTOMER.getAuditPage}`, { data: params })
}

const addAuditTags = (params: any) => {
  return request.post(`${CUSTOMER.addAuditTags}`, { data: params })
}

const getCustomerPolicy = (params: any) => {
  return request.get(`${CUSTOMER.getCustomerPolicy}`, { params })
}

const getArkOrderByParam = (params: any) => {
  return request.post(`${CUSTOMER.getArkOrderByParam}`, { data: params })
}

const updateCustomerDetail = (params: any) => {
  return request.post(`${CUSTOMER.updateCustomerDetail}`, { data: params })
}

const updateCustomerStarTarget = (id: number | string, params: any) => {
  return request.put(`${CUSTOMER.updateCustomerStarTarget}/${id}`, {
    data: params,
  })
}

const getBingdingStatus = (customerId: any) => {
  return request.get(`${CUSTOMER.getBingdingStatus}/${customerId}`)
}

const getCustomerList = (params: any) => {
  return request.get(`${CUSTOMER.getCustomerList}`, { params })
}

const bindCustomer = (params: any) => {
  return request.post(`${CUSTOMER.bindCustomer}`, { data: params })
}

const getCustomerPhoneList = (params: any) => {
  return request.get(`${CUSTOMER.getCustomerPhoneList}`, { params })
}

const getEssentialInfo = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getEssentialInfo}/${customerId}`)
}

const getCustomerBaseById = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getCustomerBaseById}/${customerId}`)
}

const getCustomerVirtualPhone = (params: any) => {
  return request.get(`${CUSTOMER.getCustomerVirtualPhone}`, { params })
}

// 旧租户十万获取虚拟号是post请求
const getCustomerVirtualPhoneByPost = (params: any) => {
  return request.post(`${CUSTOMER.getCustomerVirtualPhone}`, { data: params })
}
const getCustomerScore = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getCustomerScore}/${customerId}`)
}

const getCustomerFlows = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getCustomerJourney}/${customerId}`)
}
const getContactDetail = (params: any) => {
  return request.get(`${CUSTOMER.getContactDetail}`, { params })
}

const getAreasByParentId = (params: any) => {
  return request.get(`${CUSTOMER.getAreasByParentId}`, { params })
}

const updateCustomerStatus = (params: any) => {
  return request.post(`${CUSTOMER.updateCustomerStatus}`, { data: params })
}

const getCustomerEvent = (params: any) => {
  return request.get(`${CUSTOMER.getCustomerEvent}`, { params })
}

// 获取智能标签
const getCustomerWilling = (customerId: number | string) => {
  return request.get(`${CUSTOMER.getCustomerWilling}/${customerId}`)
}

const getAlgorithmCustomerInfo = (params: any) => {
  return request.get(`${CUSTOMER.getAlgorithmCustomerInfo}`, { params })
}
const getCommunicateDetail = (params: any) =>
  request.get(`${CUSTOMER.getCommunicateDetail}`, { params })

const getQywxFriendList = (params: any) => {
  return request.post(CUSTOMER.getQywxFriendList, {
    data: params,
  })
}

const getEmployeeInfoListByBusinessCenter = (params: any) => {
  return request.get(`${CUSTOMER.getEmployeeInfoListByBusinessCenter}`, {
    params,
  })
}

const addCustomer = (params: any) => {
  return request.post(CUSTOMER.addCustomer, {
    data: params,
  })
}

const queryCurrentCustomer = (customerId: string | number) => {
  return request.get(`${CUSTOMER.queryCurrentCustomer}/${customerId}`)
}

// const getIntentionScoreContents = (customerId: string | number) => {
//   return request.get(`${CUSTOMER.getCustomerScore}/${customerId}`)
// }

const getCurrentUserDetail = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getCurrentUserDetail}/${customerId}`)
}

const getContactMethods = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getContactMethods}/${customerId}`)
}

const getMessageTemplate = (keyword: string | number) => {
  return request.get(`${CUSTOMER.getMessageTemplate}/${keyword}`)
}

const getPreviewTemplate = (params: any) => {
  return request.get(`${CUSTOMER.getPreviewTemplate}`, { params })
}

const sendTemplate = (params: any) => {
  return request.post(`${CUSTOMER.sendTemplate}`, { data: params })
}

const addCrashInsure = (params: any) => {
  return request.post(`${CUSTOMER.addCrashInsure}`, { data: params })
}

const getContactMethodType = (customerId: string | number, params: any) => {
  return request.get(`${CUSTOMER.getContactMethodType}/${customerId}`, {
    params,
  })
}

const selectOrderInsureNo = (insureNo: string | number) => {
  return request.get(`${CUSTOMER.selectOrderInsureNo}/${insureNo}`)
}

const getPurchaseCartByMemberId = (params: any) => {
  return request.get(`${CUSTOMER.getPurchaseCartByMemberId}`, { params })
}

const getApplyBindMemberByCustomerId = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getApplyBindMemberByCustomerId}/${customerId}`)
}

const saveExceptionBinding = (params: any) => {
  return request.post(`${CUSTOMER.saveExceptionBinding}`, { data: params })
}

const getIPAddress = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getIPAddress}/${customerId}`)
}
const getCountCustomerNumber = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getCountCustomerNumber}/${customerId}`)
}

const getCustomerTasks = (params: any) => {
  return request.post(`${CUSTOMER.getCustomerTasks}`, { data: params })
}

const saveFamilyDetail = (params: any) => {
  return request.post(`${CUSTOMER.saveFamilyDetail}`, { data: params })
}

const getFamilyInfo = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getFamilyInfo}/${customerId}`)
}

const getConnectionWayNumber = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getConnectionWayNumber}/${customerId}`)
}

const getCustomerByIdOrMobile = (keyword: string | number) => {
  return request.get(`${CUSTOMER.getCustomerByIdOrMobile}/${keyword}`)
}

const deleteContactMethod = (params: any) => {
  return request.post(`${CUSTOMER.deleteContactMethod}`, { data: params })
}

const saveConnectionWayData = (params: any) => {
  return request.post(`${CUSTOMER.saveConnectionWayData}`, { data: params })
}

const updateConnectionWayData = (params: any) => {
  return request.post(`${CUSTOMER.updateConnectionWayData}`, { data: params })
}

const addBusinessOpportunity = (params: any) => {
  return request.post(`${CUSTOMER.addBusinessOpportunity}`, { data: params })
}
const saveApplyBindMember = (params: any) => {
  return request.post(`${CUSTOMER.saveApplyBindMember}`, { data: params })
}

const getPageEnterpriseTag = (params: any) => {
  return request.post(`${CUSTOMER.getPageEnterpriseTag}`, { data: params })
}

const saveCustomerLabels = (params: any) => {
  return request.post(`${CUSTOMER.saveCustomerLabels}`, { data: params })
}
///
const getFirstCommunicateResultList = (data: any) => {
  return request.get(`${CUSTOMER.getFirstCommunicateResultList}`, {
    params: data,
  })
}
// 获取家庭概况
const getFamilyOverview = (params: any) => {
  return request.get(`${CUSTOMER.getFamilyOverview}`, { params })
}

// 编辑家庭总览信息
const newSaveFamilyDetail = (params: any) => {
  return request.post(`${CUSTOMER.newSaveFamilyDetail}`, { data: params })
}
// 获取家庭总览信息
const getFamilyDetail = (params: any) => {
  return request.get(`${CUSTOMER.getFamilyDetail}`, { params })
}

// 查询个人/家庭成员信息
const getCustomerFamilyMemberInfo = (params: any) => {
  return request.get(`${CUSTOMER.getCustomerFamilyMemberInfo}`, { params })
}

// 添加和编辑个人/家庭成员信息
const addAndEditMember = (params: any) => {
  return request.post(`${CUSTOMER.addAndEditMember}`, { data: params })
}
// 获取AI标签
const getAiTag = (customerId: string | number) => {
  return request.get(`${CUSTOMER.getAiTag}/${customerId}`)
}

const getUploadUrl = (params: any) => {
  return request.get(`${CUSTOMER.getUploadUrl}`, { params })
}

// 获取标签
const getTag = (params: any) => {
  return request.post(`${CUSTOMER.getTag}`, { data: params })
}
export {
  getCustomerIdByUserId,
  getCustomerInfoByCustomerId,
  getCustomerBusinessOppo,
  getCustomerPolicy,
  updateCustomerDetail,
  getCustomerList,
  bindCustomer,
  getUnderWritingRecord,
  getClaimRecords,
  getArkOrderByParam,
  updateCustomerStarTarget,
  getBingdingStatus,
  getAuditPage,
  addAuditTags,
  getCustomerPhoneList,
  getCustomerVirtualPhone,
  getCustomerScore,
  getCustomerFlows,
  getEssentialInfo,
  getCustomerVirtualPhoneByPost,
  getCustomerBaseById,
  getCustomerWilling,
  getContactDetail,
  getAreasByParentId,
  updateCustomerStatus,
  getCustomerEvent,
  getCommunicateDetail,
  getAlgorithmCustomerInfo,
  getQywxFriendList,
  addCustomer,
  queryCurrentCustomer,
  getCurrentUserDetail,
  getEmployeeInfoListByBusinessCenter,
  getContactMethods,
  getMessageTemplate,
  getPreviewTemplate,
  sendTemplate,
  getContactMethodType,
  selectOrderInsureNo,
  getPurchaseCartByMemberId,
  saveExceptionBinding,
  addCrashInsure,
  getIPAddress,
  getApplyBindMemberByCustomerId,
  getCountCustomerNumber,
  getCustomerTasks,
  saveFamilyDetail,
  getFamilyInfo,
  getConnectionWayNumber,
  getCustomerByIdOrMobile,
  deleteContactMethod,
  saveConnectionWayData,
  updateConnectionWayData,
  addBusinessOpportunity,
  saveApplyBindMember,
  getPageEnterpriseTag,
  saveCustomerLabels,
  getFirstCommunicateResultList,
  // 获取家庭概况
  getFamilyOverview,
  // 获取家庭总览情况
  getFamilyDetail,
  // 修改总览信息
  newSaveFamilyDetail,
  getCustomerFamilyMemberInfo,
  //添加和编辑个人/家庭成员信息
  addAndEditMember,
  getAiTag,
  getUploadUrl,
  getTag,
}
